/* Hochwasser- und Starkregenschutz, Premium-Familie (starkregen-d / -e / -f): Bewegung und Bedienung.
   Additiv: Ohne dieses Skript steht jede Seite fertig da. Hier werden nur Klassen gesetzt, die
   Keyframes ausloesen, Zahlen hochgezaehlt, Bilder leicht verschoben, Regen gezeichnet, Reiter
   umgeschaltet, gerechnet, das Formular vorbefuellt und in den Warenkorb gelegt.
   Bei prefers-reduced-motion bleibt alles ruhig; Reiter, Rechner und Warenkorb funktionieren. */
(function () {
  if (window.__hwpBewegung) return;
  window.__hwpBewegung = true;

  var ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var feinzeiger = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var hatIO = 'IntersectionObserver' in window;
  document.documentElement.classList.add('hwp-js');

  function alle(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function klemme(v, a, b) { return Math.min(b, Math.max(a, v)); }
  var ganzFormat = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 0 });
  var tonFormat = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
  function ganz(n) { return ganzFormat.format(Math.round(n)); }
  function euro(n) { return ganz(n) + ' €'; }
  function gewicht(kg) { return kg < 1000 ? ganz(kg) + '\u00a0kg' : (kg >= 100000 ? ganz(kg / 1000) : tonFormat.format(kg / 1000)) + '\u00a0t'; }

  /* 1 Einblenden beim Scrollen: Klasse startet Keyframes, Ruhezustand ist sichtbar */
  alle('[data-hwp-staffel]').forEach(function (el) {
    Array.prototype.forEach.call(el.children, function (k, i) { k.style.setProperty('--hwp-i', Math.min(i, 9)); });
  });
  if (!ruhig && hatIO) {
    var ein = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('hwp-an'); ein.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px 6% 0px', threshold: 0 });
    alle('[data-hwp-rv],[data-hwp-staffel],[data-hwp-prinzip],[data-hwp-balken]').forEach(function (el) { ein.observe(el); });
  }

  /* 2 Zahlen zaehlen hoch. Endwert steht im DOM, Animation nur darueber. */
  function zaehle(el) {
    var roh = el.getAttribute('data-hwp-zahl');
    var ziel = parseFloat(roh);
    if (isNaN(ziel)) return;
    var nk = (roh.split('.')[1] || '').length;
    var endtext = el.textContent;
    el.style.display = 'inline-block';
    el.style.minWidth = el.getBoundingClientRect().width + 'px';
    var start = null, dauer = 1700;
    function schritt(t) {
      if (!start) start = t;
      var p = klemme((t - start) / dauer, 0, 1);
      var e = 1 - Math.pow(2, -10 * p);
      el.textContent = (ziel * (p === 1 ? 1 : e)).toLocaleString('de-DE', { minimumFractionDigits: nk, maximumFractionDigits: nk });
      if (p < 1) requestAnimationFrame(schritt); else el.textContent = endtext;
    }
    requestAnimationFrame(schritt);
  }
  if (!ruhig && hatIO) {
    var zo = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) { if (e.isIntersecting) { zaehle(e.target); zo.unobserve(e.target); } });
    }, { threshold: 0.6 });
    alle('[data-hwp-zahl]').forEach(function (el) { zo.observe(el); });
  }

  /* 3 Dauerschleifen (Wellen, Regen, Pulse) laufen nur, solange sie im Bild sind */
  if (hatIO) {
    var so = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) { e.target.classList.toggle('hwp-sicht', e.isIntersecting && !ruhig); });
    }, { threshold: 0.02 });
    alle('[data-hwp-sicht]').forEach(function (el) { so.observe(el); });
  }

  /* 4 Tiefe (Parallaxe) und Scroll-Fortschritt, ein gemeinsamer rAF-Takt */
  var tiefe = alle('[data-hwp-tiefe]');
  var fortschritt = alle('[data-hwp-fortschritt]');
  var tickt = false;
  function takt() {
    tickt = false;
    var vh = window.innerHeight;
    if (!ruhig) {
      tiefe.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -100 || r.top > vh + 100) return;
        var f = parseFloat(el.getAttribute('data-hwp-tiefe')) || 0.1;
        var mitte = r.top + r.height / 2 - vh / 2;
        var grenze = r.height * 0.06;
        el.style.setProperty('--hwp-py', klemme(mitte * -f, -grenze, grenze).toFixed(1) + 'px');
      });
    }
    fortschritt.forEach(function (el) {
      var box = el.closest('[data-hwp-scrolly]') || el;
      var r = box.getBoundingClientRect();
      var p = klemme((vh * 0.5 - r.top) / Math.max(r.height - vh * 0.4, 1), 0, 1);
      el.style.setProperty('--hwp-p', p.toFixed(3));
    });
  }
  function anstossen() { if (!tickt) { tickt = true; requestAnimationFrame(takt); } }
  if (tiefe.length || fortschritt.length) {
    window.addEventListener('scroll', anstossen, { passive: true });
    window.addEventListener('resize', anstossen);
    takt();
  }

  /* 5 Scroll-Geschichte: die Stufe in Bildmitte schaltet Buehne, Pegelmarke und Zaehler um */
  alle('[data-hwp-scrolly]').forEach(function (box) {
    var schritte = alle('[data-hwp-schritt]', box);
    var bilder = alle('[data-hwp-buehnenbild]', box);
    var punkte = alle('[data-hwp-punkt]', box);
    var zaehler = box.querySelector('[data-hwp-zaehler]');
    var aktuell = -1;
    function aktiviere(i) {
      if (i < 0 || i === aktuell) return;
      aktuell = i;
      bilder.forEach(function (b, k) { b.classList.toggle('ist-aktiv', k === i); });
      punkte.forEach(function (p, k) { p.classList.toggle('ist-aktiv', k <= i); });
      if (zaehler) zaehler.textContent = String(i + 1).padStart(2, '0');
    }
    aktiviere(0);
    if (!hatIO) return;
    var io = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) { if (e.isIntersecting) aktiviere(schritte.indexOf(e.target)); });
    }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
    schritte.forEach(function (s) { io.observe(s); });
  });

  /* 6 Reiter (Schutzziel-Szene): Hotspots und Reiterleiste steuern dieselben Panels.
        Ab 990 px faehrt eine Kamera auf die gewaehlte Zone (nie bei reduzierter Bewegung).
        Ohne JS stehen alle Panels untereinander, Hotspots und Reiter sind Sprunglinks. */
  var breitGenug = window.matchMedia('(min-width: 990px)');
  alle('[data-hwp-tabs]').forEach(function (box) {
    var panels = alle('[data-hwp-panel]', box);
    var ausloeser = alle('[data-hwp-tab]', box);
    var leiste = box.querySelector('[data-hwp-tableiste]');
    var kamera = box.querySelector('[data-hwp-kamera]');
    if (!panels.length) return;
    box.classList.add('hwp-tabs-an');
    if (leiste) leiste.setAttribute('role', 'tablist');
    var leistenTabs = leiste ? alle('[data-hwp-tab]', leiste) : [];
    leistenTabs.forEach(function (t) {
      var i = parseInt(t.getAttribute('data-hwp-tab'), 10);
      t.setAttribute('role', 'tab');
      if (panels[i]) t.setAttribute('aria-controls', panels[i].id);
      if (t.parentElement) t.parentElement.setAttribute('role', 'presentation');
    });
    panels.forEach(function (p) { p.setAttribute('role', 'tabpanel'); p.setAttribute('tabindex', '-1'); });
    var punkteListe = alle('.hwp-szene__punkte li', box);
    function fahre(i) {
      if (!kamera) return;
      if (ruhig || !breitGenug.matches || i < 0) { kamera.style.transform = ''; return; }
      var li = punkteListe[i];
      if (!li) return;
      var x = parseFloat(li.style.getPropertyValue('--x')) || 50, y = parseFloat(li.style.getPropertyValue('--y')) || 50;
      var z = 1.3;
      var tx = klemme(50 - x * z, (1 - z) * 100, 0), ty = klemme(55 - y * z, (1 - z) * 100, 0);
      kamera.style.transform = 'translate(' + tx.toFixed(2) + '%, ' + ty.toFixed(2) + '%) scale(' + z + ')';
    }
    function waehle(i, fokus, vonKarte) {
      ausloeser.forEach(function (t) {
        var an = parseInt(t.getAttribute('data-hwp-tab'), 10) === i;
        t.classList.toggle('ist-aktiv', an);
        if (t.getAttribute('role') === 'tab') { t.setAttribute('aria-selected', an ? 'true' : 'false'); t.setAttribute('tabindex', an ? '0' : '-1'); }
        else t.setAttribute('aria-pressed', an ? 'true' : 'false');
      });
      panels.forEach(function (p, k) {
        var an = k === i;
        p.hidden = !an;
        p.classList.remove('hwp-wechsel');
        if (an) { void p.offsetWidth; p.classList.add('hwp-wechsel'); }
      });
      box.setAttribute('data-aktiv', String(i + 1));
      fahre(i);
      if (fokus) { var t = leistenTabs[i]; if (t) t.focus(); }
      if (vonKarte && window.innerWidth < 990) {
        var ziel = leiste || panels[i];
        var y = ziel.getBoundingClientRect().top + window.pageYOffset - 90;
        window.scrollTo({ top: y, behavior: ruhig ? 'auto' : 'smooth' });
      }
    }
    ausloeser.forEach(function (t) {
      var i = parseInt(t.getAttribute('data-hwp-tab'), 10);
      t.addEventListener('click', function (ev) { ev.preventDefault(); waehle(i, false, !leiste || !leiste.contains(t)); });
    });
    leistenTabs.forEach(function (t, k) {
      t.addEventListener('keydown', function (ev) {
        var n = null, m = leistenTabs.length;
        if (ev.key === 'ArrowRight' || ev.key === 'ArrowDown') n = (k + 1) % m;
        if (ev.key === 'ArrowLeft' || ev.key === 'ArrowUp') n = (k - 1 + m) % m;
        if (ev.key === 'Home') n = 0;
        if (ev.key === 'End') n = m - 1;
        if (n !== null) { ev.preventDefault(); waehle(n, true, false); }
      });
    });
    breitGenug.addEventListener && breitGenug.addEventListener('change', function () {
      var a = parseInt(box.getAttribute('data-aktiv'), 10) - 1; fahre(a);
    });
    var start = 0;
    if (location.hash) panels.forEach(function (p, k) { if ('#' + p.id === location.hash) start = k; });
    /* Die Kamera faehrt erst, wenn die Szene im Bild ist, damit der Pegel zuerst steigt */
    panels.forEach(function (p, k) { p.hidden = k !== start; });
    ausloeser.forEach(function (t) {
      var an = parseInt(t.getAttribute('data-hwp-tab'), 10) === start;
      t.classList.toggle('ist-aktiv', an);
      if (t.getAttribute('role') === 'tab') { t.setAttribute('aria-selected', an ? 'true' : 'false'); t.setAttribute('tabindex', an ? '0' : '-1'); }
    });
  });

  /* 7 Licht auf Karten, das dem Zeiger folgt */
  if (feinzeiger && !ruhig) {
    document.addEventListener('pointermove', function (ev) {
      var k = ev.target.closest && ev.target.closest('.hwp-karte,[data-hwp-licht]');
      if (!k) return;
      var r = k.getBoundingClientRect();
      k.style.setProperty('--mx', ((ev.clientX - r.left) / r.width * 100).toFixed(1) + '%');
      k.style.setProperty('--my', ((ev.clientY - r.top) / r.height * 100).toFixed(1) + '%');
    }, { passive: true });
  }

  /* 8 Regen auf der Buehne (rein dekorativ, nur im Bild) */
  alle('canvas[data-hwp-regen]').forEach(function (cv) {
    if (ruhig || !cv.getContext) return;
    var ctx = cv.getContext('2d');
    var tropfen = [], w = 0, h = 0, dpr = Math.min(window.devicePixelRatio || 1, 2), laeuft = false, zuletzt = 0;
    function groesse() {
      var r = cv.getBoundingClientRect();
      w = r.width; h = r.height;
      cv.width = Math.round(w * dpr); cv.height = Math.round(h * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    function neu(oben) {
      var tiefe = Math.random();
      return { x: Math.random() * (w + 200) - 50, y: oben ? -20 - Math.random() * h : Math.random() * h,
        l: 10 + tiefe * 22, v: 9 + tiefe * 12, a: 0.06 + tiefe * 0.2, b: 0.6 + tiefe * 0.8 };
    }
    function bild(t) {
      if (!laeuft) return;
      var dt = Math.min((t - zuletzt) / 16.7, 3); zuletzt = t;
      var soll = Math.round(w * (w < 750 ? 0.08 : 0.12));
      while (tropfen.length < soll) tropfen.push(neu(false));
      ctx.clearRect(0, 0, w, h);
      ctx.lineCap = 'round';
      for (var i = 0; i < tropfen.length; i++) {
        var d = tropfen[i];
        d.y += d.v * dt; d.x -= d.v * 0.22 * dt;
        if (d.y - d.l > h) { tropfen[i] = neu(true); continue; }
        ctx.strokeStyle = 'rgba(220,240,245,' + d.a.toFixed(3) + ')';
        ctx.lineWidth = d.b;
        ctx.beginPath(); ctx.moveTo(d.x, d.y); ctx.lineTo(d.x + d.l * 0.22, d.y - d.l); ctx.stroke();
      }
      requestAnimationFrame(bild);
    }
    function start() { if (laeuft) return; laeuft = true; zuletzt = performance.now(); requestAnimationFrame(bild); }
    function stopp() { laeuft = false; }
    groesse();
    window.addEventListener('resize', groesse);
    if (hatIO) new IntersectionObserver(function (e) { e[0].isIntersecting && !document.hidden ? start() : stopp(); }, { threshold: 0 }).observe(cv);
    else start();
    document.addEventListener('visibilitychange', function () { if (document.hidden) stopp(); });
  });

  /* 9 Anfrage vorbefuellen: Links mit data-hwp-betreff schreiben ins Nachrichtenfeld, solange es leer ist
        oder nur eine fruehere Vorbefuellung traegt. data-hwp-ziel waehlt das Schutzziel im Formular. */
  var vorbefuellt = '';
  document.addEventListener('click', function (ev) {
    var a = ev.target.closest && ev.target.closest('a[data-hwp-betreff],a[data-hwp-ziel]');
    if (!a) return;
    var feld = document.querySelector('[data-hwp-nachricht]') || document.getElementById('AngebotForm-nachricht');
    var text = a.getAttribute('data-hwp-betreff');
    if (text && feld && (feld.value.trim() === '' || feld.value === vorbefuellt)) {
      feld.value = text; vorbefuellt = text;
      feld.dispatchEvent(new Event('input', { bubbles: true }));
      feld.classList.remove('hwp-vorbefuellt'); void feld.offsetWidth; feld.classList.add('hwp-vorbefuellt');
    }
    var ziel = a.getAttribute('data-hwp-ziel');
    var wahl = document.getElementById('HwpForm-ziel');
    if (ziel && wahl) {
      Array.prototype.forEach.call(wahl.options, function (o) { if (o.value === ziel) wahl.value = ziel; });
    }
  });

  /* 9b Bruecke fuer eingebettete Rechner anderer Familien (Beaver rescu-bvp, Lenoir rescu-lwp):
        deren Vorbefuellung sucht eigene Formularfelder; hier landen ihre Werte im hwp-Formular. */
  function hwpFormular(text, laenge) {
    var feld = document.querySelector('[data-hwp-nachricht]');
    if (feld && text && (feld.value.trim() === '' || feld.value === vorbefuellt)) {
      feld.value = text; vorbefuellt = text;
      feld.classList.remove('hwp-vorbefuellt'); void feld.offsetWidth; feld.classList.add('hwp-vorbefuellt');
    }
    var l = document.getElementById('HwpForm-laenge');
    if (l && laenge && !l.value) l.value = laenge;
  }
  document.addEventListener('click', function (ev) {
    if (!ev.target.closest || !document.querySelector('[data-hwp-nachricht]')) return;
    var b = ev.target.closest('[data-bvp-anfrage]');
    if (b) {
      setTimeout(function () { hwpFormular(b.getAttribute('data-nachricht') || ('Beaver Schlauchdamm: ' + (b.getAttribute('data-laenge') || '') + ', ' + (b.getAttribute('data-hoehe') || '')), b.getAttribute('data-laenge')); }, 0);
      return;
    }
    var l = ev.target.closest('[data-lwp-vorbelegen]');
    if (l) {
      var d = {};
      try { d = JSON.parse(l.getAttribute('data-lwp-vorbelegen') || '{}'); } catch (x) { d = {}; }
      var text = d.text || ('Lenoir®-Schutzlinie' + (d.laenge ? ' ca. ' + d.laenge : '') + (d.stau ? ', Stauhöhe ' + d.stau : ''));
      if (d.ziel && text.indexOf(d.ziel) < 0) text = 'Schutzziel: ' + d.ziel + '. ' + text;
      hwpFormular(text, d.laenge);
    }
  });

  /* 10 Rechner Sandsack gegen mobiles System.
        Sandsaecke nach THW-Berechnungsmethode wie sections/sandsack-rechner und beaver-rechner:
        4 Saecke je Meter und Reihe, Sacklagen zum Quadrat, 10 cm je Sacklage, 15 kg je Sack.
        BEAVER-Doppelelemente: Hersteller-Liste "Packmasse & Gewichte", Version 13.08.2025 (Leergewicht kg je Laenge).
        LENOIR-Typen: Herstellerangaben Lenoir AG (Leergewicht kg je 10-m-Element, ca.-Werte). */
  var BEAVER = [
    { name: 'P2 30', h: 30, l: [5, 10, 15, 20], kg: { 5: 26, 10: 28, 15: 39, 20: 50 } },
    { name: 'M2 50', h: 50, l: [5, 10, 15, 20], kg: { 5: 36, 10: 64, 15: 87, 20: 110 } },
    { name: 'M2 XL 80', h: 80, l: [5, 10, 15, 20], kg: { 5: 39, 10: 70, 15: 104, 20: 135 } },
    { name: 'H2 100', h: 100, l: [5, 10, 15, 20], kg: { 5: 74, 10: 109, 15: 144, 20: 179 } },
    { name: 'S2 130', h: 130, l: [5, 10, 15, 20], kg: { 5: 51, 10: 80, 15: 114, 20: 146 } }
  ];
  var LENOIR = [
    { name: 'LWS 15', h: 15, l: [5, 10, 15, 20], kg10: 15 },
    { name: 'LWS 35', h: 35, l: [5, 10, 15, 20], kg10: 20 },
    { name: 'LWS 50', h: 50, l: [5, 10, 15, 20], kg10: 15 },
    { name: 'LWS 70', h: 70, l: [5, 10, 15], kg10: 45 },
    { name: 'LWS 100', h: 100, l: [5, 10, 15], kg10: 60 }
  ];
  function typFuer(liste, hoehe) {
    for (var i = 0; i < liste.length; i++) if (liste[i].h >= hoehe) return liste[i];
    return null;
  }
  /* Groesste Elementlaenge so oft wie moeglich, Rest mit der kleinsten Laenge, die ihn deckt */
  function kombiniere(typ, laenge, kgJe) {
    var laengen = typ.l.slice().sort(function (a, b) { return b - a; });
    var groesste = laengen[0], anzahl = {}, gedeckt = 0;
    var n = Math.floor(laenge / groesste);
    if (n > 0) { anzahl[groesste] = n; gedeckt = n * groesste; }
    var rest = laenge - gedeckt;
    if (rest > 0) {
      var fuell = groesste;
      for (var i = laengen.length - 1; i >= 0; i--) { if (laengen[i] >= rest) { fuell = laengen[i]; break; } }
      anzahl[fuell] = (anzahl[fuell] || 0) + 1; gedeckt += fuell;
    }
    var teile = [], summe = 0, kg = 0;
    Object.keys(anzahl).map(Number).sort(function (a, b) { return b - a; }).forEach(function (len) {
      teile.push(anzahl[len] + ' × ' + len + ' m'); summe += anzahl[len]; kg += anzahl[len] * kgJe(len);
    });
    return { teile: teile, summe: summe, gedeckt: gedeckt, kg: kg };
  }
  alle('[data-hwp-rechner]').forEach(function (box) {
    var rL = box.querySelector('[data-hwp-r="regler-laenge"]');
    var rH = box.querySelector('[data-hwp-r="regler-hoehe"]');
    if (!rL || !rH) return;
    var kostenM = parseFloat(box.getAttribute('data-kosten-m')) || 690;
    var anteil = parseFloat(box.getAttribute('data-anteil')) || 70;
    function f(name) { return box.querySelector('[data-hwp-r="' + name + '"]'); }
    function setze(name, wert) {
      var el = f(name); if (!el) return;
      if (el.textContent !== wert) { el.textContent = wert; if (!ruhig) { el.classList.remove('hwp-wert-blitz'); void el.offsetWidth; el.classList.add('hwp-wert-blitz'); } }
    }
    function fuellung(r) {
      var p = (r.value - r.min) / (r.max - r.min) * 100;
      r.style.setProperty('--fill', p.toFixed(1) + '%');
    }
    function zeichne(hoehe, lagen) {
      var g = f('pyramide'); if (!g) return;
      var ns = 'http://www.w3.org/2000/svg';
      while (g.firstChild) g.removeChild(g.firstChild);
      var basis = 2 * lagen - 1;
      var bw = Math.min(16, 380 / basis), bh = 10, mitte = 210, boden = 176;
      var links = mitte - basis * bw / 2;
      var wasser = document.createElementNS(ns, 'rect');
      wasser.setAttribute('x', '0'); wasser.setAttribute('y', String(boden - hoehe));
      wasser.setAttribute('width', String(Math.max(links + bw * 2, 40))); wasser.setAttribute('height', String(hoehe));
      wasser.setAttribute('fill', '#2ab7ca'); wasser.setAttribute('fill-opacity', '.45');
      g.appendChild(wasser);
      for (var k = 0; k < lagen; k++) {
        var anz = basis - 2 * k;
        var x0 = mitte - anz * bw / 2;
        for (var j = 0; j < anz; j++) {
          var r = document.createElementNS(ns, 'rect');
          r.setAttribute('x', (x0 + j * bw + 0.5).toFixed(1)); r.setAttribute('y', String(boden - (k + 1) * bh + 0.5));
          r.setAttribute('width', (bw - 1).toFixed(1)); r.setAttribute('height', String(bh - 1)); r.setAttribute('rx', '2');
          r.setAttribute('class', 'hwp-rechner__sack');
          g.appendChild(r);
        }
      }
      var linie = document.createElementNS(ns, 'path');
      linie.setAttribute('d', 'M0 ' + (boden - hoehe) + 'H420');
      linie.setAttribute('stroke', '#f5d700'); linie.setAttribute('stroke-width', '2'); linie.setAttribute('stroke-dasharray', '6 5');
      g.appendChild(linie);
      var t = document.createElementNS(ns, 'text');
      t.setAttribute('x', '416'); t.setAttribute('y', String(boden - hoehe - 6)); t.setAttribute('text-anchor', 'end');
      t.setAttribute('class', 'hwp-rechner__bildtext'); t.textContent = 'Stauhöhe ' + hoehe + ' cm';
      g.appendChild(t);
    }
    function rechne() {
      var L = parseInt(rL.value, 10), H = parseInt(rH.value, 10);
      fuellung(rL); fuellung(rH);
      f('laenge').innerHTML = L + '<small>m</small>';
      f('hoehe').innerHTML = H + '<small>cm</small>';
      var lagen = Math.ceil(H / 10);
      var saecke = Math.ceil(4 * lagen * lagen * L);
      var kosten = kostenM * L;
      setze('saecke', ganz(saecke));
      setze('tonnen', gewicht(saecke * 15));
      setze('kosten', euro(kosten));
      setze('entsorgung', euro(kosten * anteil / 100));
      var bt = typFuer(BEAVER, H);
      if (bt) {
        var bk = kombiniere(bt, L, function (len) { return bt.kg[len]; });
        setze('beaver-anzahl', String(bk.summe));
        setze('beaver-typ', bk.summe === 1 ? 'Element ' + bt.name : 'Elemente ' + bt.name);
        setze('beaver-teile', bk.teile.join(' + ') + (bk.gedeckt > L ? ' (' + bk.gedeckt + ' m)' : ''));
        setze('beaver-gewicht', gewicht(bk.kg));
        var min = L / 100 * 60;
        var std = Math.round(L / 10) / 10;
        setze('beaver-zeit', min < 60 ? 'ca. ' + Math.max(5, Math.round(min / 5) * 5) + ' Minuten'
          : 'ca. ' + (std % 1 === 0 ? ganz(std) : tonFormat.format(std)) + (std === 1 ? ' Stunde' : ' Stunden'));
      }
      var lt = typFuer(LENOIR, H);
      var lk = box.querySelector('.hwp-rk--lenoir');
      if (lt) {
        var lw = kombiniere(lt, L, function (len) { return lt.kg10 * len / 10; });
        if (lk) lk.classList.remove('ist-aus');
        f('lenoir-hinweis').hidden = true;
        setze('lenoir-anzahl', String(lw.summe));
        setze('lenoir-typ', lw.summe === 1 ? 'Element ' + lt.name : 'Elemente ' + lt.name);
        setze('lenoir-teile', lw.teile.join(' + ') + (lw.gedeckt > L ? ' (' + lw.gedeckt + ' m)' : ''));
        setze('lenoir-gewicht', gewicht(lw.kg));
      } else {
        if (lk) lk.classList.add('ist-aus');
        f('lenoir-hinweis').hidden = false;
      }
      var zaun = f('zaun');
      if (zaun) { zaun.hidden = H > 45; setze('zaun-anzahl', ganz(Math.ceil(L))); }
      var anfrage = f('anfrage');
      if (anfrage) anfrage.setAttribute('data-hwp-betreff', 'Schutzlinie ca. ' + L + ' m, Stauhöhe ca. ' + H + ' cm' +
        (bt ? ' (Rechner: Beaver ' + bt.name + (lt ? ' oder Lenoir® ' + lt.name : '') + ')' : '') + '. Bitte Auslegung und Angebot.');
      rL.setAttribute('aria-valuetext', L + ' Meter');
      rH.setAttribute('aria-valuetext', H + ' Zentimeter');
      zeichne(H, lagen);
    }
    rL.addEventListener('input', rechne);
    rH.addEventListener('input', rechne);
    rechne();
  });

  /* 11 Warenkorb ohne Seitenwechsel: Dawn-Schublade befuellen und oeffnen.
        Ohne JS oder ohne Schublade schickt das Formular normal an /cart/add.
        Sections wie Dawns product-form von der Schublade erfragen (Kassen-Schublade b4c ersetzt sie). */
  alle('form[data-hwp-kauf]').forEach(function (form) {
    form.addEventListener('submit', function (ev) {
      var schublade = document.querySelector('cart-drawer');
      if (!schublade || typeof schublade.renderContents !== 'function' || !window.fetch) return;
      ev.preventDefault();
      var knopf = form.querySelector('button[type="submit"]');
      var label = knopf && knopf.querySelector('span');
      var alt = label ? label.textContent : '';
      if (knopf) { knopf.setAttribute('aria-busy', 'true'); knopf.disabled = true; }
      if (label) label.textContent = 'Wird hinzugefügt …';
      var daten = new FormData(form);
      var sektionen = typeof schublade.getSectionsToRender === 'function' ? schublade.getSectionsToRender().map(function (x) { return x.id; }) : ['cart-drawer', 'cart-icon-bubble'];
      daten.append('sections', sektionen.join(','));
      daten.append('sections_url', window.location.pathname);
      var ziel = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
      var hinzugefuegt = false;
      var alterHinweis = form.querySelector('.hwp-f-hinweis');
      if (alterHinweis) alterHinweis.remove();
      fetch(ziel, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: daten })
        .then(function (r) { return r.json(); })
        .then(function (antwort) {
          if (antwort.status) {
            var p = document.createElement('p');
            p.className = 'hwp-f-hinweis'; p.setAttribute('role', 'alert');
            p.innerHTML = (antwort.description || 'Gerade nicht bestellbar.') + ' <a href="#ContactForm">Angebot anfordern</a>';
            form.appendChild(p);
            if (label) label.textContent = alt;
            return;
          }
          hinzugefuegt = true;
          try {
            schublade.classList.remove('is-empty');
            schublade.renderContents(antwort);
          } catch (fehler) {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
            return;
          }
          if (label) label.textContent = 'Im Warenkorb';
          if (knopf) knopf.classList.add('ist-im-korb');
          setTimeout(function () { if (label) label.textContent = alt; if (knopf) knopf.classList.remove('ist-im-korb'); }, 2600);
        })
        .catch(function () { if (!hinzugefuegt) form.submit(); else window.location.href = '/cart'; })
        .finally(function () { if (knopf) { knopf.removeAttribute('aria-busy'); knopf.disabled = false; } });
    });
  });

  /* 12 Bildstrecke: Pfeile blaettern um eine Bildbreite */
  alle('[data-hwp-strecke]').forEach(function (box) {
    var band = box.querySelector('[data-hwp-band]');
    if (!band) return;
    alle('[data-hwp-blaettern]', box).forEach(function (b) {
      b.addEventListener('click', function () {
        var richtung = parseInt(b.getAttribute('data-hwp-blaettern'), 10) || 1;
        var erstes = band.querySelector('li');
        var schritt = erstes ? erstes.getBoundingClientRect().width + 16 : band.clientWidth * 0.8;
        band.scrollBy({ left: richtung * schritt, behavior: ruhig ? 'auto' : 'smooth' });
      });
    });
  });

  /* 13 Schwebende Anfrageleiste: nach dem Seitenkopf sichtbar, am Formular weg */
  alle('[data-hwp-sticky]').forEach(function (leiste) {
    if (!hatIO) return;
    var kopf = document.querySelector('.hwp-buehne, .hwp-szene');
    var formular = document.getElementById('ContactForm');
    var kopfWeg = false, formDa = false;
    leiste.hidden = false;
    leiste.classList.add('ist-weg');
    function stelle() { leiste.classList.toggle('ist-weg', !(kopfWeg && !formDa)); }
    if (kopf) new IntersectionObserver(function (e) { kopfWeg = !e[0].isIntersecting; stelle(); }, { threshold: 0, rootMargin: '-20% 0px 0px 0px' }).observe(kopf);
    else kopfWeg = true;
    if (formular) new IntersectionObserver(function (e) { formDa = e[0].isIntersecting; stelle(); }, { threshold: 0 }).observe(formular.closest('.shopify-section') || formular);
    stelle();
  });
})();
